<!--
Usage:
  Collapsible content section with heading and expand/collapse functionality. Heading will show on open and closed states, unless openHeading is defined. If openHeading is defined the heading shown will toggle.
Required inputs:
  heading(): string
Optional inputs:
  openHeading(): string
  content(): string
  groupName(): string
  open(): boolean
-->

<details [attr.name]="groupName()" [open]="openOnRender()" (toggle)="onClick(details)" #details>
  <!-- Clickable header with expand/collapse icon -->
  <summary class="heading">
    <!-- Display text from [heading] input or projected heading content -->
    @if (currentHeading()) {
      <span>{{ currentHeading() }}</span>
    } @else {
      <ng-content select="[slot=heading]" />
    }
    <svg width="20" height="20" viewBox="0 0 20 20" aria-hidden="true">
      <line class="vertical" x1="10" y1="0" x2="10" y2="20" stroke-width="2" stroke="currentColor" />
      <line class="horizontal" x1="0" y1="10" x2="20" y2="10" stroke-width="2" stroke="currentColor" />
    </svg>
  </summary>
  <!-- Collapsible content area -->
  <div class="content">
    @if (content()) {
      <!-- Display text from [content] input -->
      <p>{{ content() }}</p>
    } @else {
      <!-- Projected content -->
      <ng-content />
    }
  </div>
</details>
